/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';

const webhookEventSchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  platform: z.string(),
  eventType: z.string(),
  rawPayload: z.string(),
  transactionId: z.string().nullable(),
  processedAt: z.number().nullable(),
  error: z.string().nullable(),
  createdAt: z.number(),
});

export type IWebhookEvent = z.infer<typeof webhookEventSchema>;

export const listWebhookEventsDataSchema = z.array(webhookEventSchema);

export type IListWebhookEventsData = z.infer<typeof listWebhookEventsDataSchema>;

export const listWebhookEventsResponseSchema = createApiResponseSchema(
  listWebhookEventsDataSchema,
) as z.ZodSchema<IAPI<IListWebhookEventsData>>;

export type IListWebhookEventsResponse = IAPI<IListWebhookEventsData>;
